<template>
<footer class="footer" :class="{
      [`footer-${type}`]: type,
      [`footer-${size}`]: size
    }" :data-background-color="backgroundColor">
    <template v-if="$route.name !== 'ecommerce-page' && $route.name !== 'presentation'">
        <div class="container">
            <nav>
                <ul>
                    <li>
                        <a href="https://c-dev.io/index.html#kontakt" target="_blank">
                            Kontakt
                        </a>
                    </li>
                    <li>
                        <a href="https://dorfladen-netzwerk.com/index.php" target="_blank">
                            Dorfladen-Netzwerk
                        </a>
                    </li>
                    <li>
                        <a href="https://admin.dorfladen.app">
                            Login
                        </a>
                    </li>
                </ul>
            </nav>
            <div class="copyright">
                &copy; {{ year }}
                <a href="https://dorfladen-netzwerk.com/index.php" target="_blank" class="hrefColor">Vereinigung der Bürger- und Dorfläden in Deutschland e.V.</a>, coded by
                <a href="https://c-dev.io/" target="_blank" class="hrefColor">cDevelopment</a> - {{ version }}
            </div>
        </div>
    </template>
</footer>
</template>

<script>
import {
    mapGetters
} from "vuex";
export default {
    props: {
        backgroundColor: String,
        type: String,
        size: String
    },
    data() {
        return {
            year: new Date().getFullYear(),
        };
    },
    computed: {
        ...mapGetters(["version"])
    }
};
</script>

<style>
.hrefColor {
    color: #56ad45 !important;
}
</style>
